import type { ReactNode } from "react";
import { slugify } from "transliteration";

const options = { allowedChars: "a-zA-Z0-9_.~" };

const createHeadingId = (content: string[] | string | ReactNode[]) => {
  if (content === null) return "";

  switch (typeof content) {
    case "object": {
      const isHeading = content.length === 1 && typeof content[0] === "string";
      if (!isHeading) return "";
      const [heading] = content;

      return slugify(heading as string, options);
    }

    case "string": {
      return slugify(content, options);
    }

    default:
      return "";
  }
};

export default createHeadingId;
